import { ApolloProvider } from '@apollo/client';
import React from 'react';
import { graphqlClient } from './client';
const GraphQLClientProvider = ({ children }) => {
    return React.createElement(ApolloProvider, { client: graphqlClient }, children);
};
export default GraphQLClientProvider;
